import { GroupPageLayout } from '../components/GroupPageLayout'
import type { PageTabItem } from '../components/PageTabs'

const tabs: PageTabItem[] = [
    { to: '/billing/entries', labelKey: 'nav.entries' },
    { to: '/billing/reports', labelKey: 'nav.reports' },
    { to: '/billing/invoices', labelKey: 'nav.invoices' },
    { to: '/billing/monthly', labelKey: 'nav.monthly' },
]

/**
 * Rahmen der Gruppe „Abrechnung“ — Sub-Routen: Einträge, Berichte,
 * Rechnungen, Monatstunden (Arbeitszeit-Verwaltung,
 * KONZEPT_ARBEITSZEIT.md).
 */
export function BillingPage() {
    return (
        <GroupPageLayout
            titleKey='billing.title'
            subtitleKey='billing.subtitle'
            tabs={tabs}
        />
    )
}
